module.exports = __webpack_public_path__ + "img/happybrain_info1.7d57ef6f.jpg";